import React, {useState} from 'react'
import loadable from '@loadable/component'
// Components
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'
import {routes as _routes} from '@salesforce/retail-react-app/app/routes'
const fallback = <Skeleton height="75vh" width="100%" />
const LeftNavLayout = loadable(() => import('./components/left-nav-layout'), {fallback})
const LeftNav = loadable(() => import('./components/left-nav'), {fallback})

// About us pages
const AboutUsContent = loadable(() => import('./pages/content/about-us/about-us'), {fallback})
const Careers = loadable(() => import('./pages/content/about-us/careers'), {fallback})
const CommunitySupportContent = loadable(
    () => import('./pages/content/about-us/community-support'),
    {fallback}
)
const TeamCavenders = loadable(() => import('./pages/content/about-us/team-cavenders'), {fallback})
const TeamCavendersApplication = loadable(
    () => import('./pages/content/about-us/team-cavenders-application'),
    {fallback}
)

const AboutUs = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <AboutUsContent />
    </LeftNavLayout>
)

const CommunitySupport = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <CommunitySupportContent />
    </LeftNavLayout>
)

const AboutUsroutes = [
    {
        path: '/content/about-us.html',
        component: AboutUs,
        exact: true
    },
    {
        path: '/content/career.html',
        component: Careers,
        exact: true
    },
    {
        path: '/content/community-support.html',
        component: CommunitySupport,
        exact: true
    },
    {
        path: '/content/team-cavenders.html',
        component: TeamCavenders,
        exact: true
    },
    {
        path: '/content/team-cavenders-application.html',
        component: TeamCavendersApplication,
        exact: true
    }
]

export default AboutUsroutes
